import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-13f723d6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "product__operating"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "cms-card-block brand-info"
};
const _hoisted_4 = {
  key: 0,
  class: "nodata-warp"
};
const _hoisted_5 = {
  class: "tips"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_7 = {
  style: {
    "display": "block",
    "color": "#f56c6c",
    "font-size": "14px",
    "line-height": "20px"
  }
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("VOD");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("VOD_Plus");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("VOD_Pro");

const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_15 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_16 = {
  class: "cms-module-title mg-t--15"
};
const _hoisted_17 = {
  class: "upload--tip mg-b--15"
};
const _hoisted_18 = {
  class: "btn_middle",
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_19 = {
  class: "btn_middle"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dialog-footer"
}, null, -1));

import MasterBrandItem from './Components/MasterBrandItem/index.vue';
import UploadImage from './Components/UploadImage/index.vue';
import NoData from '@/components/NoData/index.vue';
import BrandLogoInfo from './Components/BrandLogoInfo/index.vue';
import RecommendOperation from './RecommendOperation/index.vue';
import OnDemand from './OnDemand/index.vue';
import LiveChannelCategory from './LiveChannelCategory/index.vue';
import { useCommon } from '@/store/useCommon';
import { useRouter } from 'vue-router';
import { onMounted, nextTick, computed } from 'vue';
import { getServerGroupsApi } from '@/api/live';
import { clearData, getItemByProp, removePropertyOfNull } from '@/utils/tools';
import { OperatingStatus } from '@/assets/config/dicts';
import { PrefixInteger, useVodLanguages } from '@/utils/cacheData';
import { elMessage, getTextWidth } from '@/utils';
import { messageBox, validatorNonNull } from '@/utils/validate';
import { useI18n } from 'vue-i18n';
import { useAgentProtocolList } from '@/utils/cacheData';
import { getBrandList, getPlatformList } from '@/api/common';
import { addSubAgentApi, editSubAgentApi, disassociateSubAgentApi, getBrandListApi, getPlatformListApi, getAppStyleOptionsApi, relationSubAgentApi, getSubAgentByIdApi, deleteSubAgentApi, getMainSubAgentListApi, getMainAgentSortApi, getSubAgentSortApi, addMainAgentApi, getMainAgentByIdApi, editMainAgentApi, deleteMainAgentApi, getOptionListApi } from '@/api/vodNew';
import { getSysDictListApi } from '@/api/live';
import { ElMessage } from 'element-plus';
import { themeTypeOptions } from '@/assets/config/dicts';
import { RecycleScroller } from 'vue-virtual-scroller';
const __default__ = {
  name: 'ProductOperating'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const {
      t
    } = useI18n();
    const labelOptions = ref([]);
    const router = useRouter();
    const mainAgentSorts = ref([]);
    const storeCommon = useCommon();
    const sortOptions = ref([]); //排序下拉选项

    const copyMainAgentList = ref([]);
    const subAgentList = ref([]); //子品牌数据

    const ownPermission = computed(() => {
      return useCommon().userData.permissionKey || [];
    });
    const showUploadImage = ref(false);
    const serverGroupOptions = ref(); // 是否为VNO账号

    const isVnoUser = computed(() => storeCommon.userData.roles.includes('VNO') || storeCommon.userData.roles.includes('VNO_CMS'));
    const currentSelectValue = ref(null); // 简化模板类名判断

    const isAddSubBrand = computed(() => actionForm.action === 'addSubBrand');
    const isLiveActive = computed(() => actionForm.subFormData.operationModules.includes('LIVE'));
    const isVodActive = computed(() => actionForm.subFormData.operationModules.includes('VOD') || actionForm.subFormData.operationModules.includes('VOD_PLUS') || actionForm.subFormData.operationModules.includes('VOD_PRO'));
    const isMyLinkActive = computed(() => actionForm.subFormData.operationModules.includes('MyLink'));
    const recommendOperation = reactive({
      visible: false,
      pageParams: {
        agentId: '',
        uiStyle: 0,
        uiDirection: 0,
        categoryId: '',
        subAgentId: undefined,
        categoryName: '',
        // 在dynamicTable中区分是VOD_PLUS还是VOD_PRO
        moduleType: ''
      }
    });
    const onDemand = reactive({
      visible: false,
      pageParams: {
        categoryId: '',
        subAgentId: undefined
      }
    });
    const liveCategory = reactive({
      visible: false,
      pageParams: {
        categoryParentId: undefined,
        programType: undefined,
        rootId: undefined,
        update: undefined,
        subAgentId: undefined
      }
    }); // 创建子品牌选择弹窗

    const createSubBrandDialog = reactive({
      visible: false,
      mainBrandItem: null
    }); // 校验排序

    const validatorSequence = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入排序')));
      } else if (value && value.length > 4) {
        callback(new Error(t('限制字符数量', {
          num: 4
        })));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else {
        callback();
      }
    };

    onMounted(() => {
      getSysDictList();
      getAppStyleOptions();
      getBrands();
    }); // 获取协议

    const getAgentProtocolList = async () => {
      const agentProtocolList = await useAgentProtocolList();
      const item = getItemByProp(actionForm.subFormList, 'protocolId');
      if (item) item.list = agentProtocolList;
    };

    const uiStyleOptions = ref([{
      uiId: 0,
      uiName: 'Default'
    }, {
      uiId: 1,
      uiName: 'Simple no image'
    }, {
      uiId: 2,
      uiName: 'Simple'
    }]); // 品牌产品数据

    const products = ref([]);
    const formRef = ref(null);
    const imageItemRef = ref(null);
    const emptyLoading = ref(false);
    const brandsOptions = ref([]); // 获取品牌选项数据

    const getBrands = async () => {
      try {
        emptyLoading.value = true;

        if (storeCommon.userData.permissionKey.indexOf('OP_PO_BS') > -1) {
          let ids = storeCommon.userData.cid && storeCommon.userData.cid.join(',');
          const brands = await getOptionsList(1, ids);
          let searchItem = getItemByProp(searchConfig.formList, 'brand');
          let formItem = getItemByProp(actionForm.formList, 'cids');
          if (searchItem) searchItem.list = brands;
          if (formItem) formItem.list = [{
            prefixName: t('全部'),
            cid: -1
          }, ...brands];
          brandsOptions.value = brands; // 注：直播分类用到productOperationsCid

          const cid = sessionStorage.getItem('productOperationsCid');

          if (!cid && brands.length > 0) {
            sessionStorage.setItem('productOperationsCid', isVnoUser.value ? storeCommon.userData.cid[0] : brands[0].value);
            searchConfig.formData.brand = isVnoUser.value ? storeCommon.userData.cid[0] : brands[0].value;
          }
        } else {
          const cid = sessionStorage.getItem('productOperationsCid');

          if (!cid) {
            sessionStorage.setItem('productOperationsCid', storeCommon.userData.cid[0] || 0);
            searchConfig.formData.brand = storeCommon.userData.cid[0] || 0;
          }
        }

        getMainSubAgentList();
      } catch (error) {
        console.error('获取品牌选项数据失败:', error);
        emptyLoading.value = false;
        elMessage('error', '获取品牌选项数据失败');
      }
    };

    const platformsOptions = ref([]); // 获取平台选项数据

    const getPlatform = async () => {
      let ids = storeCommon.userData.cid && storeCommon.userData.cid.join(','); // const platforms = await usePlatformsByUser()

      const platforms = await getPlatformLists({
        cids: ids == 0 ? '' : ids
      });
      let item = getItemByProp(actionForm.formList, 'pids');
      if (item) item.list = [{
        prefixName: t('全部'),
        pid: -1
      }, ...platforms];
      platformsOptions.value = platforms;
    };

    const getOptionsList = async (type, cid, pid) => {
      try {
        const {
          code,
          data
        } = type == 1 ? await getBrandListApi(cid) : await getPlatformListApi(cid);

        if (code == 0) {
          let resData = data.map(item => {
            return { ...item,
              prefixName: PrefixInteger(item.id, 3) + '-' + item.name,
              value: item.id
            };
          }); // cid:0 增加phone选项

          if (!storeCommon.userData.cid[0] && type == 2) resData.push({
            id: 1000,
            pid: 1000,
            prefixName: '1000-phone'
          });
          return resData;
        }

        return [];
      } catch (error) {
        console.error('获取选项列表失败:', error);
        elMessage('error', '获取选项列表失败');
        return [];
      }
    };

    const getBrandLists = async params => {
      try {
        let res = await getBrandList(params);

        if (res.code == '0') {
          let resData = res.data.map(item => ({ ...item,
            prefixName: PrefixInteger(item.cid, 3) + '-' + item.name
          }));
          return resData;
        }

        return [];
      } catch (error) {
        console.error('获取品牌列表失败:', error);
        elMessage('error', '获取品牌列表失败');
        return [];
      }
    };

    const getPlatformLists = async params => {
      try {
        let res = await getPlatformList(params);

        if (res.code == '0') {
          let resData = res.data.map(item => ({ ...item,
            prefixName: PrefixInteger(item.pid, 3) + '-' + item.name
          })); // cid:0 增加phone选项

          if (!storeCommon.userData.cid[0]) resData.push({
            id: 1000,
            pid: 1000,
            prefixName: '1000-phone'
          });
          return resData;
        }

        return [];
      } catch (error) {
        console.error('获取平台列表失败:', error);
        elMessage('error', '获取平台列表失败');
        return [];
      }
    };

    const searchConfig = reactive({
      formList: [{
        label: '品牌',
        prop: 'brand',
        widgetType: 'Select',
        labelKey: 'prefixName',
        list: [],
        clearable: false,
        filterable: true,
        change: val => {
          currentSelectValue.value = null;
          sessionStorage.setItem('productOperationsCid', val);
          getMainSubAgentList();
        },
        visibleChange: visible => {
          if (!visible) {
            setTimeout(() => {
              document.querySelector('#brand-select') && document.querySelector('#brand-select').blur();
            });
          }
        },
        id: 'brand-select',
        controller: () => {
          return storeCommon.userData.permissionKey.indexOf('OP_PO_BS') > -1;
        } // disabled: storeCommon.userData.roles.includes('VNO'),

      }],
      formData: {
        brand: Number(sessionStorage.getItem('productOperationsCid'))
      },
      loading: false
    });
    const subFormList = ref([[{
      label: '运营模块',
      prop: 'operationModules',
      colspan: 3,
      itemSlot: true,
      required: true,
      change: val => {
        console.log('运营模块', val);
      },
      controller: () => {
        return actionForm.action !== 'AssociatedSubBrand';
      }
    }], [{
      label: '运营模块',
      prop: 'operationModulesNew',
      colspan: 3,
      itemSlot: true,
      required: true,
      controller: () => {
        return actionForm.action == 'AssociatedSubBrand';
      }
    }], [{
      label: '选择主品牌',
      prop: 'relationMainAgentId',
      widgetType: 'Select',
      required: true,
      list: copyMainAgentList,
      labelKey: 'name',
      valueKey: 'id',
      change: relationMainAgentId => {
        getSubAgentList(relationMainAgentId);
      },
      controller: () => {
        return actionForm.action == 'AssociatedSubBrand';
      }
    }, {
      label: '选择子品牌',
      prop: 'relationSubAgentId',
      widgetType: 'Select',
      valueKey: 'id',
      labelKey: 'name',
      list: subAgentList,
      required: true,
      controller: () => {
        return actionForm.action == 'AssociatedSubBrand';
      },
      change: id => {
        changeRelationAgentId(id);
      }
    }], [{
      label: '子品牌名称',
      prop: 'name',
      widgetType: 'input',
      required: true
    }, {
      label: '状态',
      prop: 'status',
      widgetType: 'Select',
      translation: true,
      list: [...OperatingStatus, {
        label: '终端审核',
        value: 2
      }],
      required: true
    }], [{
      label: '排序',
      prop: 'sequence',
      widgetType: 'Select',
      valueKey: 'id',
      labelKey: 'name',
      required: true,
      list: sortOptions
    }, {
      label: '成人分类',
      prop: 'adult',
      widgetType: 'Select',
      required: true,
      list: [{
        label: '是',
        value: 18
      }, {
        label: '否',
        value: 0
      }],
      translation: true,
      disabled: false,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }, {
      label: '备注',
      prop: 'remark',
      widgetType: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      autosize: true,
      rules: [{
        max: 200,
        message: t('限制字符数量', {
          num: '200'
        }),
        trigger: 'blur'
      }],
      required: false,
      controller: () => {
        return actionForm.subFormData.operationModules.includes('MyLink');
      }
    }], [{
      label: '服务器地址组',
      prop: 'serverGroup',
      widgetType: 'Select',
      list: serverGroupOptions,
      disabled: false,
      controller: () => {
        return actionForm.subFormData.operationModules.includes('LIVE');
      }
    }, {
      label: '二级分类显示',
      prop: 'showSecondCategory',
      widgetType: 'Select',
      list: [{
        label: '否',
        value: 0
      }, {
        label: '是',
        value: 1
      }],
      translation: true,
      controller: () => {
        return actionForm.subFormData.operationModules.includes('LIVE');
      }
    }], [{
      label: 'Ecos UI 风格',
      prop: 'uiStyle',
      labelKey: 'uiName',
      valueKey: 'uiId',
      widgetType: 'Select',
      required: false,
      list: uiStyleOptions,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }, {
      label: 'Label',
      prop: 'label',
      widgetType: 'Select',
      valueKey: 'label',
      list: labelOptions,
      controller: () => {
        return actionForm.subFormData.operationModules.includes('LIVE');
      }
    }, {
      label: 'UI方向',
      prop: 'uiDirection',
      widgetType: 'Select',
      required: true,
      list: [{
        label: 'Normal',
        value: 0
      }, {
        label: 'Arabic',
        value: 1
      }],
      disabled: false,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }], [{
      label: '剧集试看集数',
      prop: 'seriesPreviewCount',
      widgetType: 'input',
      type: 'number',
      append: t('集数'),
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }, {
      label: '单片试看时间',
      prop: 'programPreviewMinute',
      widgetType: 'input',
      type: 'number',
      append: t('分钟'),
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }], [{
      label: '主题方式',
      prop: 'themeType',
      widgetType: 'Select',
      list: themeTypeOptions,
      multiple: true,
      required: true,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }, {
      label: 'Label',
      prop: 'label',
      widgetType: 'Select',
      valueKey: 'label',
      list: labelOptions,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }], [{
      label: '备注',
      prop: 'remark',
      widgetType: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      autosize: true,
      colspan: 3,
      rules: [{
        max: 200,
        message: t('限制字符数量', {
          num: '200'
        }),
        trigger: 'blur'
      }],
      required: false,
      controller: () => {
        return !actionForm.subFormData.operationModules.includes('MyLink');
      }
    }]]); // 新增编辑model

    const actionForm = reactive({
      visible: false,
      // 子品牌图片路径
      imgUrl: '',
      // 主品牌大图路径
      masterBigLogo: '',
      // 主品牌小图路径
      masterSmallLogo: '',
      action: '',
      formList: [[{
        label: '主品牌名称',
        prop: 'name',
        widgetType: 'input',
        required: true
      }, {
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        translation: true,
        list: [...OperatingStatus, {
          label: '终端审核',
          value: 2
        }],
        required: true
      }], [{
        label: '编码标准',
        prop: 'videoCode',
        widgetType: 'Select',
        list: [{
          label: 'H.264',
          value: 'H264'
        }, {
          label: 'H.265',
          value: 'H265'
        }],
        required: true
      }, {
        label: '排序',
        prop: 'sequence',
        widgetType: 'Select',
        list: [],
        valueKey: 'id',
        labelKey: 'name',
        required: true
      }], [{
        label: '选择品牌',
        prop: 'cids',
        widgetType: 'Select',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: [],
        multiple: true,
        collapseTags: true,
        'collapse-tags-tooltip': true,
        filterable: true,
        required: true,
        itemSlot: true,
        controller: () => {
          // return !isVnoUser.value
          return storeCommon.userData.permissionKey.indexOf('OP_PO_CIDS') > -1;
        }
      }, {
        label: '选择平台',
        prop: 'pids',
        widgetType: 'Select',
        labelKey: 'prefixName',
        valueKey: 'pid',
        list: [],
        multiple: true,
        collapseTags: true,
        'collapse-tags-tooltip': true,
        filterable: true,
        required: true,
        itemSlot: true,
        controller: () => {
          // return !isVnoUser.value
          return storeCommon.userData.permissionKey.indexOf('OP_PO_PIDS') > -1;
        }
      }], [{
        label: '选择型号',
        prop: 'cpmIds',
        widgetType: 'selectModel',
        colspan: 3,
        searchFormData: {
          cid: [],
          pid: []
        },
        disabledBrand: storeCommon.userData.permissionKey.indexOf('OP_PO_CPMIDS') > -1,
        controller: () => {
          return searchConfig.formData.brand != 0 && storeCommon.userData.permissionKey.indexOf('OP_PO_CPMIDS') > -1;
        }
      }], [{
        label: 'APP风格',
        prop: 'appStyle',
        labelKey: 'name',
        valueKey: 'id',
        widgetType: 'Select',
        list: []
      }, {
        label: '备注',
        prop: 'remark',
        widgetType: 'textarea',
        maxlength: 200,
        showWordLimit: true,
        autosize: true,
        rules: [{
          max: 200,
          message: t('限制字符数量', {
            num: '200'
          }),
          trigger: 'blur'
        }],
        required: false
      }]],
      formData: {
        name: '',
        status: 1,
        videoCode: 'H264',
        sequence: '',
        cids: [],
        pids: [],
        cpmIds: [],
        remark: '',
        agentPicture: [// 大图标
        {
          base64Image: '',
          url: '',
          type: 1
        }, // 小图标
        {
          base64Image: '',
          url: '',
          type: 2
        }]
      },
      subFormList: subFormList,
      subFormData: {
        name: '',
        status: 1,
        sequence: '',
        operationModules: '',
        protocolId: '',
        language: '',
        appraisal: '',
        enterAddress: '',
        adult: 0,
        serverGroup: '',
        uiStyle: 0,
        uiDirection: 0,
        type: 'static',
        seriesPreviewCount: '',
        programPreviewMinute: '',
        remark: '',
        logoInfo: {
          base64Image: '',
          type: 1,
          url: ''
        },
        mainAgentId: '',
        relationAgentId: '',
        showSecondCategory: 1
      },
      rules: {
        name: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, actionForm.action == 'addMasterBrand' || actionForm.action == 'editMasterBrand' ? '请输入主品牌名称' : '请输入子品牌名称'),
          trigger: 'blur'
        }, {
          required: true,
          max: 100,
          message: t('限制字符数量', {
            num: '100'
          }),
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: t('请选择状态'),
          trigger: 'change'
        }],
        videoCode: [{
          required: true,
          message: t('请选择编码标准'),
          trigger: 'change'
        }],
        language: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        enterAddress: [{
          max: 500,
          message: t('限制字符数量', {
            num: '500'
          }),
          trigger: 'blur'
        }],
        appraisal: [{
          max: 500,
          message: t('限制字符数量', {
            num: '500'
          }),
          trigger: 'blur'
        }],
        operationModules: [{
          required: true,
          trigger: ['change', 'blur'],
          message: t('请选择运营模块')
        }],
        sequence: [{
          required: true,
          trigger: 'blur',
          validator: validatorSequence
        }],
        cids: [{
          required: true,
          message: t('请选择品牌'),
          trigger: 'change'
        }],
        pids: [{
          required: true,
          message: t('请选择平台'),
          trigger: 'change'
        }],
        themeType: [{
          required: true,
          message: t('请选择主题方式'),
          trigger: 'blur'
        }],
        seriesPreviewCount: [{
          validator: (rule, value, callback) => {
            if (value && value.length > 4) {
              callback(new Error(t('限制字符数量', {
                num: 4
              })));
            } else if (value && !/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        programPreviewMinute: [{
          validator: (rule, value, callback) => {
            if (value && value.length > 4) {
              callback(new Error(t('限制字符数量', {
                num: 4
              })));
            } else if (value && !/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        mainAgentId: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value == '') {
              callback(new Error(t('请选择子品牌')));
            } else if (value !== '') {
              const findItem = copyMainAgentList.value.find(item => item.id == value);

              if (findItem.count == 5) {
                callback(new Error(t('主品牌已包含5个子品牌, 不可以继续添加')));
                formRef.value.mForm.resetFields('sequence');
              } else {
                callback();
              }
            }
          },
          trigger: 'change'
        }],
        relationMainAgentId: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value == '' || !value) return callback(new Error(t('请选择主品牌')));
            callback();
          },
          trigger: 'change'
        }],
        relationSubAgentId: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value == '' || !value) return callback(new Error(t('请选择子品牌')));
            callback();
          },
          trigger: 'change'
        }]
      },
      dialogConfig: {
        title: '新增',
        destroyOnClose: true
      },
      fileOnChange: file => {
        // 预览图片
        let reader = new FileReader(); //转base64

        reader.onload = function (e) {
          //将图片路径赋值给src
          actionForm.imgUrl = e.target.result;
          nextTick(() => {
            imageItemRef.value.validateField('imgUrl');
          });
        };

        reader.readAsDataURL(file.raw);
      },
      confirm: done => {
        Promise.all([formRef.value.mForm.validate(), imageItemRef.value.validate()]).then(async valid => {
          if (valid) {
            if (actionForm.action == 'addMasterBrand') {
              addOrEditMasterBrand('add', done);
            } else if (actionForm.action == 'editMasterBrand') {
              addOrEditMasterBrand('edit', done);
            } else if (actionForm.action == 'addSubBrand') {
              addSubAgent('add', done);
            } else if (actionForm.action == 'editSubBrand') {
              addSubAgent('edit', done);
            } else if (actionForm.action == 'copySubBrand') {
              relationSubAgent(done);
            } else if (actionForm.action == 'AssociatedSubBrand') {
              relationSubAgent(done);
            }
          }
        }).catch(err => {
          done();
        });
      }
    }); // 记录上一次的运营模块选择，用于判断互斥项的最后选择项

    const prevOperationModules = ref([]); // 创建/编辑主品牌

    const addOrEditMasterBrand = async (type, done) => {
      try {
        actionForm.formData.name = actionForm.formData.name.trim();
        const cid = sessionStorage.getItem('productOperationsCid');
        let agentPicture = [];
        actionForm.formData.agentPicture.forEach(item => {
          let newItem = removePropertyOfNull(item);
          agentPicture.push(removePropertyOfNull(newItem));
        });
        let params = removePropertyOfNull({ ...actionForm.formData,
          cid,
          agentPicture
        });
        let cids = actionForm.formData.cids.includes(-1) ? [{
          id: -1,
          name: ''
        }] : brandsOptions.value.filter(item => actionForm.formData.cids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.name
          };
        });
        let pids = actionForm.formData.pids.includes(-1) ? [{
          id: -1,
          name: ''
        }] : platformsOptions.value.filter(item => actionForm.formData.pids.includes(item.value)).map(item => {
          return {
            id: item.value,
            name: item.name
          };
        });
        let mids = actionForm.formData.cpmIds ? actionForm.formData.cpmIds.map(item => {
          return {
            cid: item.cid,
            pid: item.pid,
            mid: item.mid,
            brandName: item.brandName,
            platformName: item.platformName,
            modelName: item.modelName
          };
        }) : [];
        let postData = {
          cids,
          pids,
          mids,
          cid: searchConfig.formData.brand,
          logoInfos: actionForm.formData.agentPicture,
          appStyle: actionForm.formData.appStyle,
          name: actionForm.formData.name,
          remark: actionForm.formData.remark,
          sequence: actionForm.formData.sequence,
          status: actionForm.formData.status,
          videoCode: actionForm.formData.videoCode
        };
        console.log(' postData', postData);
        const res = type == 'add' ? await addMainAgentApi(postData) : await editMainAgentApi({ ...postData,
          id: actionForm.formData.id
        });

        if (res.code == '0') {
          elMessage('success', type == 'add' ? '新增成功' : '编辑成功');
          actionForm.visible = false;
          getMainSubAgentList();
        }

        done();
      } catch (error) {
        console.log(error);
        done();
      }
    }; // 创建/编辑子品牌


    const addSubAgent = async (type, done) => {
      try {
        let params = { ...actionForm.subFormData
        };
        params.name = actionForm.subFormData.name.trim();
        params.logoInfo = removePropertyOfNull(actionForm.subFormData.logoInfo);
        params.themeType = params.themeType ? params.themeType.join(',') : undefined;
        const res = type == 'add' ? await addSubAgentApi(params) : await editSubAgentApi(params);

        if (res.code == '0') {
          elMessage('success', type == 'add' ? '新增成功' : '编辑成功');
          actionForm.visible = false;
          getMainSubAgentList();
        }

        done();
      } catch (error) {
        console.log(error);
        done();
      }
    }; // 关联子品牌


    const relationSubAgent = async done => {
      try {
        let params = { ...actionForm.subFormData
        };
        params.name = actionForm.subFormData.name.trim();
        params.logoInfo = removePropertyOfNull(actionForm.subFormData.logoInfo);
        params.themeType = params.themeType ? params.themeType.join(',') : undefined;
        params.mainAgentId = mainBrandItemObj.value.id; //todo 关联失败code50000

        const res = await relationSubAgentApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          actionForm.visible = false;
          getMainSubAgentList();
        }

        done();
      } catch (error) {
        console.log('957ERR', error);
        done();
      }
    }; // 获取子品牌排序列表


    const getSubAgentSort = async mainAgentId => {
      try {
        const {
          code,
          data
        } = await getSubAgentSortApi(mainAgentId);

        if (code == 0) {
          sortOptions.value = data.length ? data.map(item => {
            return { ...item,
              name: t(item.name)
            };
          }) : [];
        }
      } catch (error) {
        console.error('获取子品牌排序列表失败:', error);
        elMessage('error', '获取子品牌排序列表失败');
      }
    }; // 获取子品牌排序列表


    const getMainAgentSort = async () => {
      try {
        const {
          code,
          data
        } = await getMainAgentSortApi(searchConfig.formData.brand);

        if (code == 0) {
          mainAgentSorts.value = data.length ? data.map(item => {
            return { ...item,
              name: t(item.name)
            };
          }) : [];
        }

        let item = getItemByProp(actionForm.formList, 'sequence');
        if (item) item.list = mainAgentSorts.value;
      } catch (error) {
        console.error('获取主品牌排序列表失败:', error);
        elMessage('error', '获取主品牌排序列表失败');
      }
    }; // 子品牌组件 el-dropdown 组件鼠标悬浮点击事件


    const handleAction = async item => {
      console.log('855-item', item);
      const {
        type,
        data,
        mainBrandItem
      } = item;

      if (type === 'delete') {
        deleteBrand(data, mainBrandItem);
      } else if (type === 'edit') {
        getSubAgentSort(mainBrandItem.id);
        mainBrandItemObj.value = mainBrandItem;
        subBrandItemObj.value = data;
        actionForm.dialogConfig.title = '编辑子品牌';
        actionForm.action = 'editSubBrand';
        getSubBrandInfo(data.id);
      } else if (type === 'copy') {
        // return elMessage('warning', '功能开发中......')
        actionForm.action = 'copySubBrand';
        mainBrandItemObj.value = mainBrandItem;
        subBrandItemObj.value = data;
        actionForm.dialogConfig.title = '复制子品牌';
        getCopyMainAgent();
        setCopyInfo({ ...data,
          mainAgentId: mainBrandItem.mainAgentId
        });
      } else if (type == 'disassociate') {
        //解除关联
        onDisassociateSubBrand(item);
      }
    }; // 解除关联子品牌


    const onDisassociateSubBrand = item => {
      const {
        mainBrandItem
      } = item;

      if (item.data.status === 1 || item.data.status === 2) {
        return elMessage('warning', '请先停运子品牌，再操作解除关联');
      }

      messageBox('确定解除关联吗？').then(async () => {
        try {
          const {
            code
          } = await disassociateSubAgentApi(item.data.id);

          if (code == '0') {
            elMessage('success', '解除关联成功');
            getMainSubAgentList();
          }
        } catch (error) {
          console.error('解除关联子品牌失败:', error);
          elMessage('error', '解除关联子品牌失败');
        }
      });
    }; // 设置复制子品牌信息


    const setCopyInfo = async ({
      id,
      mainAgentId
    }) => {
      try {
        const {
          code,
          data
        } = await getSubAgentByIdApi({
          mainAgentId,
          id
        });

        if (code === '0') {
          actionForm.subFormData = { ...data,
            mainAgentId: '',
            subAgentId: data.id,
            sequence: '',
            logoInfo: {
              base64Image: '',
              type: 1,
              url: ''
            }
          };
        }

        actionForm.visible = true;
      } catch (error) {
        console.error('设置复制子品牌信息失败:', error);
        elMessage('error', '设置复制子品牌信息失败');
      }
    }; // 获取复制弹窗选择主品牌下拉数据


    const getCopyMainAgent = async () => {
      // const cid = searchConfig.formData.brand
      // const res = await getCopyMainAgentApi({ cid }) as ResType
      const res = mainSubAgentList.value.length ? mainSubAgentList.value.map(item => {
        return {
          name: item.name,
          id: item.id
        };
      }) : [];
      let masterNameItem = getItemByProp(actionForm.subFormList, 'relationMainAgentId');
      masterNameItem.list = res;
      copyMainAgentList.value = res;
    }; // 删除子品牌


    const deleteBrand = (item, mainAgentId) => {
      if (item.status === 1 || item.status === 2) {
        return elMessage('warning', '请先停运子品牌，再操作删除');
      }

      messageBox('确认将子品牌删除吗?').then(async () => {
        const {
          code
        } = await deleteSubAgentApi(item.id);

        if (code == '0') {
          if (item.id == currentSelectValue.value) {
            currentSelectValue.value = null;
          }

          elMessage('success', '删除成功');
          getMainSubAgentList();
        }
      });
    }; // 获取子品牌详情信息


    const getSubBrandInfo = async id => {
      try {
        const cid = searchConfig.formData.brand; // const { code, data } = await getSubBrandInfoApi({ id }) as ResType

        const {
          code,
          data
        } = await getSubAgentByIdApi(id);

        if (code == '0') {
          console.log('1066=======', data);
          actionForm.subFormData = { ...data
          };
          actionForm.subFormData.uiDirection = data.uiDirection ? data.uiDirection : 0;
          actionForm.subFormData.themeType = data.themeType ? data.themeType.split(',') : []; // 回显图片

          actionForm.imgUrl = data.logoInfo.url || '';
          actionForm.visible = true;
          console.log('actionForm.subFormData952', actionForm.subFormData);
        }
      } catch (error) {}
    }; // 获取所有语言


    const getLangs = async () => {
      const langs = await useVodLanguages();
      let item = getItemByProp(actionForm.subFormList, 'language'); // item.list = langs //todo,因为隐藏了语言所以会报错
    };

    const mainSubAgentList = ref([]); // 获取主子品牌相关信息列表

    const getMainSubAgentList = async () => {
      mainSubAgentList.value = [];
      searchConfig.loading = true;

      try {
        const {
          brand: cid
        } = searchConfig.formData;
        const res = await getMainSubAgentListApi({
          cid
        });

        if (res.code == '0') {
          mainSubAgentList.value = res.data ? res.data.map(item => {
            // 子品牌的列表长度，+1的1是后面带加号的卡片
            let subAgentLength = item.subAgents.length + 1 - 6; // 计算主品牌卡片高度，每6个子品牌高度增加310px

            let size = 430 + Math.ceil((subAgentLength > 0 ? subAgentLength : 0) / 6) * 310;
            return { ...item,
              uniqueId: item.id,
              size
            };
          }) : []; //console.log('mainSubAgentList.value', mainSubAgentList.value)
        }
      } catch (error) {}

      emptyLoading.value = false;
      searchConfig.loading = false;
    };

    const operatingModulesObjNew = {
      'OP_PO_IPTV': 'LIVE',
      'OP_PO_VOD': 'VOD',
      'OP_PO_VP': 'VOD_PLUS',
      'OP_PO_VPP': 'VOD_PRO'
    }; // 根据用户权限，从传入的 data（运营模块下拉数据）中过滤出用户可见的模块项
    // 参数 data：下拉数据数组，元素至少包含 id 字段
    // 返回值：仅包含用户有权限的模块项的数组

    const getOperatingModulesSelectListNew = data => {
      // 用户拥有的权限键集合（如：['OP_PO_IPTV', 'OP_PO_VOD']）
      const permissionKey = storeCommon.userData.permissionKey || []; // 将拥有的权限键映射为允许的模块 ID，并用 Set 加速查找

      const allowedModuleIds = new Set(Object.keys(operatingModulesObjNew).filter(key => permissionKey.includes(key)).map(key => operatingModulesObjNew[key])); // 依据允许的模块 ID 集合，过滤下拉数据项

      const filterSelectList = (data || []).filter(item => allowedModuleIds.has(item.id)); // 调试输出：可删除

      console.log('filterSelectList', filterSelectList);
      return filterSelectList;
    };

    const getOperationModuleList = async () => {
      const {
        code,
        data
      } = await getOptionListApi('OperationModuleEnum');

      if (code == 0) {
        let item = getItemByProp(actionForm.subFormList, 'operationModules'); // 是否有全部下拉数据权限

        if (storeCommon.userData.permissionKey.includes('OP_PO_OMA')) {
          if (item) item.list = data;
        } else {
          if (item) item.list = getOperatingModulesSelectListNew(data);
        }
      }
    }; // 根据id获取运营模块


    const onModuleItemClick = async item => {
      console.log('点了v965', item);

      switch (item.moduleItem) {
        case 'LIVE':
          const {
            code,
            data
          } = await getSubAgentByIdApi(item.subId);

          if (code == 0) {
            liveCategory.visible = true;
            liveCategory.pageParams.categoryParentId = item.categoryId; //子品牌分类id

            liveCategory.pageParams.programType = Number(data.videoCode); //子品牌编码标准 0:h264 1:h265

            liveCategory.pageParams.rootId = data.mainAgentId; // 品牌的id

            liveCategory.pageParams.update = 1; // 关联的，传关联子品牌

            liveCategory.pageParams.subAgentId = item.relationSubAgentId ? item.relationSubAgentId : item.subId;
          } else {
            ElMessage({
              type: 'error',
              message: t('失败')
            });
          }

          break;

        case 'VOD_PLUS':
          recommendOperation.visible = true;
          recommendOperation.pageParams.agentId = item.relationSubAgentId ? item.relationSubAgentId : item.subId;
          recommendOperation.pageParams.uiStyle = item.uiStyle ? item.uiStyle : 0;
          recommendOperation.pageParams.uiDirection = item.uiDirection ? item.uiDirection : 0;
          recommendOperation.pageParams.categoryId = item.VodCategoryId;
          recommendOperation.pageParams.categoryName = item.name;
          recommendOperation.pageParams.moduleType = 'VOD_PLUS';
          break;

        case 'VOD_PRO':
          recommendOperation.visible = true;
          recommendOperation.pageParams.agentId = item.relationSubAgentId ? item.relationSubAgentId : item.subId;
          recommendOperation.pageParams.uiStyle = item.uiStyle ? item.uiStyle : 0;
          recommendOperation.pageParams.uiDirection = item.uiDirection ? item.uiDirection : 0;
          recommendOperation.pageParams.categoryId = item.VodCategoryId;
          recommendOperation.pageParams.categoryName = item.name;
          recommendOperation.pageParams.moduleType = 'VOD_PRO';
          break;

        default:
          onDemand.visible = true; // 有关联的用relationSubAgentId来请求

          onDemand.pageParams.subAgentId = item.relationSubAgentId ? item.relationSubAgentId : item.subId;
          break;
      }
    }; // 从直播分类返回 (LiveChannelCategory => 主页面)


    const onReturnFromLiveCategory = () => {
      liveCategory.visible = false;
    }; // 获取服务器地址组下拉数据


    const getServerGroups = async () => {
      const res = await getServerGroupsApi();
      serverGroupOptions.value = res.data;
    };

    const selectBrandAll = () => {
      // if (actionForm.formData.cids.length < brandsOptions.value.length) {
      //   actionForm.formData.cids = []
      //   brandsOptions.value.map((item) => {
      //     actionForm.formData.cids.push(item.value)
      //   })
      //   actionForm.formData.cids.unshift(-1)
      // } else {
      //   actionForm.formData.cids = []
      // }
      actionForm.formData.cids = [-1];
    };

    const brandSelectChage = val => {
      if (!val.includes(-1) && searchConfig.formData.brand == 0 && val.length == brandsOptions.value.length) {
        actionForm.formData.cids.unshift(-1);
      } else if (val.includes(-1) && val.length - 1 < actionForm.formData.cids.length) {
        actionForm.formData.cids = actionForm.formData.cids.filter(item => {
          return item !== -1;
        });
      }
    };

    const removeBrandTag = val => {
      if (val === -1) {
        actionForm.formData.cids = [];
      }
    };

    const selectPlatformsAll = () => {
      // if (actionForm.formData.pids.length < platformsOptions.value.length) {
      //   actionForm.formData.pids = []
      //   platformsOptions.value.map((item) => {
      //     actionForm.formData.pids.push(item.value)
      //   })
      //   actionForm.formData.pids.unshift(-1)
      // } else {
      //   actionForm.formData.pids = []
      // }
      actionForm.formData.pids = [-1];
    };

    const platformsSelectChage = val => {
      if (!val.includes(-1) && searchConfig.formData.brand == 0 && val.length == platformsOptions.value.length) {
        actionForm.formData.pids.unshift(-1);
      } else if (val.includes(-1) && val.length - 1 < actionForm.formData.pids.length) {
        actionForm.formData.pids = actionForm.formData.pids.filter(item => {
          return item !== -1;
        });
      }
    };

    const removePlatformsTag = val => {
      if (val === -1) {
        actionForm.formData.pids = [];
      }
    };

    const onUploadImageComfirm = (params, done) => {
      const {
        type,
        base64Image,
        url,
        file
      } = params; // 0 输入URL

      if (type == 0) {
        if (uploadPictureType.value == 'sub') {
          actionForm.imgUrl = url;
          actionForm.subFormData.logoInfo.url = url;
          nextTick(() => {
            imageItemRef.value.validateField('imgUrl');
          });
        } else if (uploadPictureType.value == 'big') {
          actionForm.masterBigLogo = url;
          actionForm.formData.agentPicture[0].url = url;
          nextTick(() => {
            imageItemRef.value.validateField('masterBigLogo');
          });
        } else if (uploadPictureType.value == 'small') {
          actionForm.masterSmallLogo = url;
          actionForm.formData.agentPicture[1].url = url;
          nextTick(() => {
            imageItemRef.value.validateField('masterSmallLogo');
          });
        }
      } // 1 上传图片
      else {
        if (uploadPictureType.value == 'sub') {
          actionForm.imgUrl = base64Image;
          actionForm.subFormData.logoInfo.url = '';
          actionForm.subFormData.logoInfo.base64Image = base64Image.split('base64,')[1];
          nextTick(() => {
            imageItemRef.value.validateField('imgUrl');
          });
        } else if (uploadPictureType.value == 'big') {
          actionForm.masterBigLogo = base64Image;
          actionForm.formData.agentPicture[0].url = '';
          actionForm.formData.agentPicture[0].base64Image = base64Image.split('base64,')[1];
          nextTick(() => {
            imageItemRef.value.validateField('masterBigLogo');
          });
        } else if (uploadPictureType.value == 'small') {
          actionForm.masterSmallLogo = base64Image;
          actionForm.formData.agentPicture[1].url = '';
          actionForm.formData.agentPicture[1].base64Image = base64Image.split('base64,')[1];
          nextTick(() => {
            imageItemRef.value.validateField('masterSmallLogo');
          });
        }
      }

      done();
    }; // 回显上传图片url


    const urlStr = ref(''); // 区分主品牌还是子品牌点击的上传图片 'big'主品牌大图 'small'主品牌小图 'sub'子品牌

    const uploadPictureType = ref('');

    const onLogoClick = type => {
      type == 'big' ? urlStr.value = actionForm.formData.agentPicture[0].url || '' : type == 'small' ? urlStr.value = actionForm.formData.agentPicture[1].url || '' : type == 'sub' ? urlStr.value = actionForm.subFormData.logoInfo.url || '' : urlStr.value = '';
      uploadPictureType.value = type;
      showUploadImage.value = true;
    }; // 创建主品牌按钮点击事件


    const onMasterBrandClick = async () => {
      const cid = searchConfig.formData.brand; // 初始化数据

      resetFromData();
      getMainAgentSort();
      actionForm.action = 'addMasterBrand';
      actionForm.dialogConfig.title = '创建主品牌';

      if (storeCommon.userData.permissionKey.indexOf('OP_PO_CIDS') > -1 && storeCommon.userData.permissionKey.indexOf('OP_PO_PIDS') > -1) {
        try {
          if (Number(cid) == 0) {
            brandsOptions.value = await getOptionsList(1);
            platformsOptions.value = await getOptionsList(2);
            selectBrandAll();
            selectPlatformsAll();
          } else {
            brandsOptions.value = await getOptionsList(1, cid);
            platformsOptions.value = await getOptionsList(2, cid);
            actionForm.formData.cids = [brandsOptions.value[0].value];
          }
        } catch (error) {
          console.log(error);
        }
      } else {}

      actionForm.formData.appStyle = 'Apollo';
      actionForm.visible = true;
    }; // 当前主品牌的信息(用于创建或编辑限制排序输入)


    const mainBrandItemObj = ref(null); // 当前子品牌的信息

    const subBrandItemObj = ref(null); // 创建子品牌按钮点击事件

    const createSubBtnClick = async mainBrandItem => {
      mainBrandItemObj.value = mainBrandItem;
      resetSubFormData();
      actionForm.action = 'addSubBrand';
      actionForm.dialogConfig.title = '创建子品牌';
      actionForm.subFormData.mainAgentId = mainBrandItem.id;
      await getSubAgentSort(mainBrandItem.id);
      let item = getItemByProp(actionForm.subFormList, 'sequence');
      console.log('item', item);
      actionForm.visible = true;
    }; // 创建关联子品牌按钮点击事件


    const createCopyBtnClick = mainBrandItem => {
      actionForm.action = 'AssociatedSubBrand';
      mainBrandItemObj.value = mainBrandItem;
      subBrandItemObj.value = {};
      actionForm.dialogConfig.title = '关联子品牌';
      getCopyMainAgent();
      getSubAgentSort(mainBrandItem.id);
      actionForm.subFormData = {
        mainAgentId: '',
        sequence: '',
        logoInfo: {
          base64Image: '',
          type: 1,
          url: ''
        },
        operationModules: ['LIVE']
      };
      actionForm.visible = true;
    }; // 显示创建子品牌选择弹窗


    const showCreateSubBrandDialog = mainBrandItem => {
      createSubBrandDialog.mainBrandItem = mainBrandItem;
      createSubBrandDialog.visible = true;
    }; // 处理创建子品牌选择


    const handleCreateSubBrand = type => {
      createSubBrandDialog.visible = false;

      if (type === 'subBrand') {
        // 创建子品牌
        createSubBtnClick(createSubBrandDialog.mainBrandItem);
      } else {
        // 创建关联子品牌
        createCopyBtnClick(createSubBrandDialog.mainBrandItem);
      }
    }; // 关闭创建子品牌弹窗


    const handleCreateSubBrandDialogClose = () => {
      createSubBrandDialog.visible = false;
      createSubBrandDialog.mainBrandItem = null;
    }; // 响应组件主品牌删除按钮点击事件


    const onDeleteMasterBtnClick = mainBrandItem => {
      if (mainBrandItem.subAgents && mainBrandItem.subAgents.length) {
        return elMessage('warning', '请先删除主品牌下的子品牌，再操作删除');
      }

      if (mainBrandItem.status === 1 || mainBrandItem.status === 2) {
        return elMessage('warning', '请先停运主品牌，再操作删除');
      }

      messageBox('确认将主品牌删除吗?').then(async () => {
        const {
          brand: cid
        } = searchConfig.formData;
        const res = await deleteMainAgentApi(mainBrandItem.id);

        if (res.code == '0') {
          elMessage('success', '删除成功');
          getMainSubAgentList();
        }
      });
    }; // 响应组件主品牌编辑按钮点击事件


    const onEditMasterBtnClick = async mainAgentId => {
      actionForm.action = 'editMasterBrand';
      actionForm.dialogConfig.title = '编辑主品牌';

      try {
        const {
          brand: cid
        } = searchConfig.formData;
        getMainAgentSort();
        const res = await getMainAgentByIdApi(mainAgentId);

        if (res.code == '0') {
          // actionForm.formData = { ...res.data }
          if (res.data.logoInfos) {
            res.data.logoInfos.forEach(item => {
              if (item.type == 1) {
                actionForm.masterBigLogo = item.url;
              } else {
                actionForm.masterSmallLogo = item.url;
              }
            });
          }

          actionForm.formData = { ...res.data,
            cids: res.data.cids ? res.data.cids.map(item => item.id) : [],
            pids: res.data.pids ? res.data.pids.map(item => item.id) : [],
            cpmIds: res.data.mids,
            videoCode: res.data.videoCode,
            agentPicture: res.data.logoInfos
          };
          actionForm.visible = true;

          if (storeCommon.userData.permissionKey.indexOf('OP_PO_CIDS') > -1 && storeCommon.userData.permissionKey.indexOf('OP_PO_PIDS') > -1) {
            try {
              if (Number(cid) == 0) {
                brandsOptions.value = await getOptionsList(1);
                platformsOptions.value = await getOptionsList(2); // actionForm.formData.cids.length == brandsOptions.value.length ? actionForm.formData.cids.unshift(-1) : ''
                // actionForm.formData.pids.length == platformsOptions.value.length ? actionForm.formData.pids.unshift(-1) : ''
              } else {
                brandsOptions.value = await getOptionsList(1, cid);
                platformsOptions.value = await getOptionsList(2, cid);
              }
            } catch (error) {
              console.log(error);
            }
          } else {}
        }
      } catch (error) {
        console.log('1321err', error);
      }
    }; // 重置主品牌数据表单


    const resetFromData = () => {
      brandsOptions.value = [];
      platformsOptions.value = [];
      clearData(actionForm.formData);
      actionForm.formData.status = 1;
      actionForm.formData.videoCode = 'H264';
      actionForm.masterBigLogo = '';
      actionForm.masterSmallLogo = '';
      actionForm.formData.agentPicture = [// 大图标
      {
        base64Image: '',
        url: '',
        type: 1
      }, // 小图标
      {
        base64Image: '',
        url: '',
        type: 2
      }];
    }; // 重置子品牌数据表单


    const resetSubFormData = () => {
      clearData(actionForm.subFormData);
      actionForm.subFormData.status = 1;
      actionForm.subFormData.adult = 0;
      actionForm.subFormData.uiStyle = 0;
      actionForm.subFormData.showSecondCategory = 1;
      actionForm.subFormData.uiDirection = 0;
      actionForm.subFormData.type = 'static';
      actionForm.imgUrl = '';
      actionForm.subFormData.logoInfo = {
        base64Image: '',
        type: 1,
        url: ''
      };
      sortOptions.value = [];
      actionForm.subFormData.operationModules = ['LIVE']; //默认直播
    }; // 选择运营模块栏点击事件


    const onClickAgentCategory = arr => {
      if (actionForm.action !== 'addSubBrand') return false;
      console.log('arr', arr); //重置数据

      actionForm.subFormData.name = '';
      actionForm.subFormData.remark = '';
      actionForm.subFormData.logoInfo = {
        base64Image: '',
        type: 1,
        url: ''
      };
      actionForm.subFormData.operationModules = arr;
    }; // VOD、VOD_Plus都不勾选时，默认激活选项按钮


    const onAgentCategoryChange = val => {
      if (val.length === 0) {
        actionForm.subFormData.operationModules = ['LIVE'];
      } // VOD_PLUS和VOD_PRO是互斥的


      const current = Array.isArray(val) ? [...val] : [];
      const prev = Array.isArray(prevOperationModules.value) ? [...prevOperationModules.value] : [];
      const added = current.find(item => !prev.includes(item)); // 如果同时出现两个互斥项，根据最后新增的那个来决定

      const hasPlus = current.includes('VOD_PLUS');
      const hasPro = current.includes('VOD_PRO');

      if (hasPlus && hasPro) {
        if (added === 'VOD_PLUS') {
          actionForm.subFormData.operationModules = current.filter(item => item !== 'VOD_PRO');
        } else if (added === 'VOD_PRO') {
          actionForm.subFormData.operationModules = current.filter(item => item !== 'VOD_PLUS');
        } else {
          // 无法判断新增项时，默认保留当前已勾选中的第一个，移除另一个
          // 这里优先保留用户原来已有的那个
          if (prev.includes('VOD_PLUS')) {
            actionForm.subFormData.operationModules = current.filter(item => item !== 'VOD_PRO');
          } else {
            actionForm.subFormData.operationModules = current.filter(item => item !== 'VOD_PLUS');
          }
        }
      } // 记录本次的选择，为下次变更判断“新增项”使用


      prevOperationModules.value = [...actionForm.subFormData.operationModules];
    }; // 过滤拿到子品牌选项


    const getSubAgentList = mainAgentId => {
      // 选择了主品牌, 过滤mainSubAgentList,赋值给relationAgentId，进行选择
      actionForm.subFormData.relationSubAgentId = '';
      let targetAgentList = mainSubAgentList.value.filter(item => item.id == mainAgentId);
      let subAgents = targetAgentList.length ? targetAgentList[0].subAgents : [];
      subAgentList.value = subAgents.filter(item => item.relationSubAgentId == null); // 过滤关联的子品牌
      // console.log('过滤的选项', subAgentList.value)
    }; // 选择子品牌选项变化的change事件


    const changeRelationAgentId = async id => {
      const res = await getSubAgentByIdApi(id); // 获取对应子品牌的数据

      if (res.code == 0 && res.data) {
        // 复显成人分类、服务器组、ui方向数据、运营模块
        actionForm.subFormData.adult = res.data.adult;
        actionForm.subFormData.operationModules = res.data.operationModules;

        if (actionForm.subFormData.operationModules.includes('LIVE')) {
          // 直播
          actionForm.subFormData.serverGroup = res.data.serverGroup;
        } else {
          // 点播
          actionForm.subFormData.uiDirection = res.data.uiDirection; // 复现主题类型

          actionForm.subFormData.themeType = res.data.themeType ? res.data.themeType.split(',') : [];
        }
      }
    }; // 设置subFormList的选项禁用


    const setSubFormListDisable = name => {
      let item = getItemByProp(actionForm.subFormList, name);
      item.disabled = actionForm.action === 'AssociatedSubBrand' ? true : false;
    }; // app风格选项


    const getAppStyleOptions = async () => {
      const {
        code,
        data
      } = await getAppStyleOptionsApi();

      if (code == 0) {
        let item = getItemByProp(actionForm.formList, 'appStyle');
        if (item) item.list = data;
      }
    }; //监听operationModules变化，改变subFormList配置项 


    watch(() => actionForm.subFormData.operationModules, (newVal, oldVal) => {
      if (newVal) {
        if (newVal.includes('LIVE')) {
          //直播
          setSubFormListDisable('serverGroup');
          setSubFormListDisable('adult'); // 显示二级分类默认:是  ui风格默认default

          actionForm.subFormData.showSecondCategory = actionForm.subFormData.showSecondCategory == 0 ? actionForm.subFormData.showSecondCategory : 1;
          actionForm.subFormData.uiStyle = actionForm.subFormData.uiStyle ? actionForm.subFormData.uiStyle : 0;
        } else if (newVal.includes('MyLink')) {} else {
          //点播
          setSubFormListDisable('uiDirection');
          setSubFormListDisable('adult');
        }
      }
    }, {
      deep: true
    }); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth > width;
    }; // 字典


    const getSysDictList = async () => {
      const {
        code,
        data
      } = await getSysDictListApi('agent_label');

      if (code == 0) {
        labelOptions.value = data ? data : [];
      }
    };

    watch(() => actionForm.visible, async val => {
      if (val) {
        nextTick(() => {
          formRef.value.mForm.resetFields();
          imageItemRef.value.resetFields();
        });
      }

      if (val && (actionForm.action == 'addSubBrand' || actionForm.action == 'editSubBrand' || actionForm.action == 'copySubBrand' || actionForm.action == 'AssociatedSubBrand')) {
        getServerGroups();
        getOperationModuleList(); // getAllOperating()
        // getAgentProtocolList()

        getLangs();
      }
    });
    watch(() => [actionForm.formData.cids, actionForm.formData.pids], val => {
      let item = getItemByProp(actionForm.formList, 'cpmIds'); // if (storeCommon.userData.permissionKey.indexOf('OP_PO_CPMIDS') > -1) {
      //   item.searchFormData.cid = [storeCommon.userData.cid[0]]
      //   return
      // }

      item.searchFormData.cid = val[0] && val[0].filter(item => item != -1);
      item.searchFormData.pid = val[1] && val[1].filter(item => item != -1);
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_SearchForm = _resolveComponent("SearchForm");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_form = _resolveComponent("el-form");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      const _directive_permission = _resolveDirective("permission");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [emptyLoading.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [[_directive_loading, emptyLoading.value]]) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(ownPermission).includes('OP_PO_BS') || _unref(ownPermission).includes('OP_PO_MC') ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_SearchForm, {
        isCardBlock: false,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        "is-show-btns": false
      }, null, 8, ["form-list", "form-data"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: onMasterBrandClick,
        class: "cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建主品牌')), 1)]),
        _: 1
      })), [[_directive_permission, 'OP_PO_MC']])])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_unref(RecycleScroller), {
        items: mainSubAgentList.value,
        buffer: 400,
        "page-mode": true,
        "size-field": "size",
        "key-field": "uniqueId",
        "min-item-size": 430
      }, {
        default: _withCtx(({
          item,
          index
        }) => [_createVNode(MasterBrandItem, {
          "info-item": item,
          onHandleCommand: handleAction,
          onAddSubBrand: createSubBtnClick,
          onCreateSubBtnClick: createSubBtnClick,
          onOnEditMasterBtnClick: onEditMasterBtnClick,
          onOnDeleteMasterBtnClick: onDeleteMasterBtnClick,
          onOnModuleItemClick: onModuleItemClick,
          onCreateCopySubBtnClick: createCopyBtnClick,
          onShowCreateSubBrandDialog: showCreateSubBrandDialog
        }, null, 8, ["info-item"])]),
        _: 1
      }, 8, ["items"]), !mainSubAgentList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [!mainSubAgentList.value.length && !searchConfig.loading ? (_openBlock(), _createBlock(NoData, {
        key: 0
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('您还没有主品牌，点击 “创建” 按钮创建。')), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: onMasterBrandClick,
          class: "cms-op-btn cms-op-btn-main"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建主品牌_c')), 1)]),
          _: 1
        })), [[_directive_permission, 'OP_PO_MC']])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])), [[_directive_loading, searchConfig.loading]])], 64)), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '60%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [actionForm.action == 'addSubBrand' || actionForm.action == 'editSubBrand' || actionForm.action == 'copySubBrand' || actionForm.action == 'AssociatedSubBrand' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 0,
          ref_key: "formRef",
          ref: formRef,
          col: ['20%', '30%', '20%', '30%'],
          "form-data": actionForm.subFormData,
          rules: actionForm.rules
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.subFormList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.subFormData
            }, {
              itemSlot: _withCtx(scope => [scope.prop == 'ifRelated' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_select, {
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                modelValue: actionForm.subFormData.ifRelated,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actionForm.subFormData.ifRelated = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: _ctx.$t('是'),
                  value: true
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  label: _ctx.$t('否'),
                  value: false
                }, null, 8, ["label"])]),
                _: 1
              }, 8, ["modelValue"]), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('关联后两个子品牌修改自动同步')), 1)])) : _createCommentVNode("", true), scope.prop == 'operationModules' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = $event => onClickAgentCategory(['LIVE'])),
                class: _normalizeClass(['div_btn', {
                  btn_active: _unref(isLiveActive),
                  not_allow: !_unref(isAddSubBrand)
                }])
              }, _toDisplayString(_ctx.$t('直播')), 3), _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = $event => onClickAgentCategory(['VOD', 'VOD_PLUS'])),
                class: _normalizeClass(['div_btn', {
                  btn_active: _unref(isVodActive),
                  not_allow: !_unref(isAddSubBrand)
                }])
              }, _toDisplayString(_ctx.$t('点播')), 3), !actionForm.subFormData.operationModules.includes('LIVE') && !actionForm.subFormData.operationModules.includes('MyLink') ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 0,
                modelValue: actionForm.subFormData.operationModules,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => actionForm.subFormData.operationModules = $event),
                onChange: onAgentCategoryChange,
                style: {
                  "margin-right": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                  label: 'VOD',
                  disabled: actionForm.action !== 'addSubBrand'
                }, {
                  default: _withCtx(() => [_hoisted_10]),
                  _: 1
                }, 8, ["disabled"]), _createVNode(_component_el_checkbox, {
                  label: 'VOD_PLUS',
                  disabled: actionForm.action !== 'addSubBrand'
                }, {
                  default: _withCtx(() => [_hoisted_11]),
                  _: 1
                }, 8, ["disabled"]), _createVNode(_component_el_checkbox, {
                  label: 'VOD_PRO',
                  disabled: actionForm.action !== 'addSubBrand'
                }, {
                  default: _withCtx(() => [_hoisted_12]),
                  _: 1
                }, 8, ["disabled"])]),
                _: 1
              }, 8, ["modelValue"])) : _createCommentVNode("", true), !_unref(useCommon)().userData.cid[0] ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['div_btn', {
                  btn_active: _unref(isMyLinkActive),
                  not_allow: !_unref(isAddSubBrand)
                }]),
                onClick: _cache[4] || (_cache[4] = $event => onClickAgentCategory(['MyLink']))
              }, " My Link ", 2)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), scope.prop == 'operationModulesNew' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
                class: _normalizeClass(['div_btn', 'not_allow', actionForm.subFormData.relationSubAgentId ? 'btn_active' : ''])
              }, _toDisplayString(actionForm.subFormData.operationModules.includes('LIVE') ? _ctx.$t('直播') : actionForm.subFormData.operationModules.includes('VOD') ? _ctx.$t('点播') : _ctx.$t('My Link')), 3)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data", "rules"])) : _createCommentVNode("", true), actionForm.action == 'addMasterBrand' || actionForm.action == 'editMasterBrand' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 1,
          ref_key: "formRef",
          ref: formRef,
          col: ['20%', '30%', '20%', '30%'],
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop == 'cids' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_select, {
                filterable: "",
                "reserve-keyword": false,
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                modelValue: actionForm.formData.cids,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => actionForm.formData.cids = $event),
                onChange: brandSelectChage,
                onRemoveTag: removeBrandTag
              }, {
                default: _withCtx(() => [searchConfig.formData.brand == 0 ? (_openBlock(), _createBlock(_component_el_option, {
                  key: 0,
                  label: _ctx.$t('全部'),
                  value: -1,
                  onClick: selectBrandAll
                }, null, 8, ["label"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandsOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.prefixName,
                    value: item.value
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                      disabled: tipDisabled.value,
                      effect: "light",
                      "popper-class": "self-popper",
                      content: item.prefixName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", {
                        onMouseover: showTextTip,
                        class: "tooltip-item"
                      }, _toDisplayString(item.prefixName), 33)]),
                      _: 2
                    }, 1032, ["disabled", "content"])]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])])) : _createCommentVNode("", true), scope.prop == 'pids' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_select, {
                filterable: "",
                "reserve-keyword": false,
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                modelValue: actionForm.formData.pids,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => actionForm.formData.pids = $event),
                onChange: platformsSelectChage,
                onRemoveTag: removePlatformsTag
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: _ctx.$t('全部'),
                  value: -1,
                  onClick: selectPlatformsAll
                }, null, 8, ["label"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformsOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.prefixName,
                    value: item.value
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                      disabled: tipDisabled.value,
                      effect: "light",
                      "popper-class": "self-popper",
                      content: item.prefixName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", {
                        onMouseover: showTextTip,
                        class: "tooltip-item"
                      }, _toDisplayString(item.prefixName), 33)]),
                      _: 2
                    }, 1032, ["disabled", "content"])]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data", "rules"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('上传图片')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('温馨提示：图片大小建议在500KB以内。')), 1), _createElementVNode("div", null, [_createVNode(_component_el_form, {
          model: actionForm,
          ref_key: "imageItemRef",
          ref: imageItemRef
        }, {
          default: _withCtx(() => [_createVNode(BrandLogoInfo, {
            "picture-list": actionForm.action == 'addSubBrand' || actionForm.action == 'editSubBrand' || actionForm.action == 'copySubBrand' || actionForm.action == 'AssociatedSubBrand' ? [actionForm.subFormData.logoInfo] : actionForm.formData.agentPicture,
            onOnLogoClick: onLogoClick
          }, null, 8, ["picture-list"])]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"]), _createVNode(UploadImage, {
        modelValue: showUploadImage.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showUploadImage.value = $event),
        urlStr: urlStr.value,
        onOnComfirm: onUploadImageComfirm
      }, null, 8, ["modelValue", "urlStr"]), _createVNode(_component_el_dialog, {
        "custom-class": "my_dialog",
        modelValue: createSubBrandDialog.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => createSubBrandDialog.visible = $event),
        width: "20%",
        "before-close": handleCreateSubBrandDialogClose
      }, {
        footer: _withCtx(() => [_hoisted_20]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
          style: {
            "width": "200px",
            "height": "40px"
          },
          onClick: _cache[9] || (_cache[9] = $event => handleCreateSubBrand('subBrand'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建子品牌')), 1)]),
          _: 1
        })]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
          style: {
            "width": "200px",
            "height": "40px"
          },
          onClick: _cache[10] || (_cache[10] = $event => handleCreateSubBrand('relation'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建关联子品牌')), 1)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, !recommendOperation.visible && !onDemand.visible && !liveCategory.visible]]), onDemand.visible ? (_openBlock(), _createBlock(OnDemand, {
        key: 0,
        "page-params": onDemand.pageParams,
        "return-back-fn": () => onDemand.visible = false
      }, null, 8, ["page-params", "return-back-fn"])) : _createCommentVNode("", true), recommendOperation.visible ? (_openBlock(), _createBlock(RecommendOperation, {
        key: 1,
        "page-params": recommendOperation.pageParams,
        "return-back-fn": () => recommendOperation.visible = false
      }, null, 8, ["page-params", "return-back-fn"])) : _createCommentVNode("", true), liveCategory.visible ? (_openBlock(), _createBlock(LiveChannelCategory, {
        key: 2,
        "page-params": liveCategory.pageParams,
        "return-back-fn": onReturnFromLiveCategory
      }, null, 8, ["page-params"])) : _createCommentVNode("", true)], 64);
    };
  }

});